import React, {useContext} from 'react'
import { FlightContext} from '../context/FlightContext';

export default function UpdateDayFlight({formData, detail, handleFormChange}) {
   const {routes} = useContext(FlightContext)
  //  const [routes,setRoutes] = useState([])
   
   
  return (
   <details className='bg-secondary bg-opacity-10 border border-secondary mb-3 border rounded px-1 py-2'>
          <summary className='ps-2'>Add Flight</summary>
        
        <div className='row justify-content-center'>
        
         <div className=" mb-3 col-md-11 ">
            <label htmlFor={`flight_route-${detail.day}`} className="form-label">Route:</label>
            <select
            id={`flight_route-${detail.day}`}
            className="form-control border-success"
            value={formData[detail.day]?.flight_route || detail.flight_route || ""}
            onChange={(e) => handleFormChange(detail.day, 'flight_route', e.target.value)}
            // // value={route?.origin?.location - route?.destination?.location}
            // value={formData[detail.day]?.flight_route || newItinerary && newItinerary.find(item => item.day === detail.day)?.flight_route || ""}
            // onChange={(e) => handleFormChange(detail.day, 'flight_route', e.target.value)}
            
            >
           <option value="" disabled>Select Route</option>
           <option style={{backgroundColor:'lightblue'}} value='None'>None</option>
           {Array.isArray(routes) && routes.length > 0 && routes.map((route) => (
             <option
               key={route.id}
               value={route.id}
               style={{ fontWeight: 'semibold',fontFamily:'junge' }} // Style for the name
             >
               {route?.origin?.location} - {route?.destination?.location}   ({route?.flight_name}) ${route?.rates}
             </option>
           ))}
         </select>
       </div>

        </div>
    </details>
  )
}
